import { graphql, useStaticQuery } from "gatsby"
import { Family, Route } from "../global"
import { ModelGroup } from "../components/organisms/Series/ModelList/ModelList.d"

const useModelData = () => {
  const data2 = useStaticQuery(graphql`
    query {
      allSanityFamily {
        nodes {
          routes {
            route {
              page {
                ... on SanityPageSeries {
                  title
                  vehicle {
                    year
                    series {
                      name
                    }
                    models {
                      ... on SanityVehicleModel {
                        _key
                        _type
                        model {
                          ... on SanityModel {
                            _id
                            id
                            name
                            grade
                            year
                            series {
                              name
                              currentYear
                            }
                            code
                          }
                          ... on SanityCustomModel {
                            _id
                            id
                            name
                            grade
                            year
                            series {
                              name
                              currentYear
                            }
                          }
                        }
                      }
                      ... on SanityVehicleModelGroup {
                        _key
                        _type
                        title
                        models {
                          model {
                            ... on SanityModel {
                              _id
                              id
                              name
                              code
                              grade
                              series {
                                currentYear
                                name
                              }
                              year
                            }
                            ... on SanityCustomModel {
                              _id
                              id
                              name
                              grade
                              year
                              series {
                                name
                                currentYear
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  relatedSeriesPage {
                    page {
                      ... on SanityPageSeries {
                        id
                        vehicle {
                          series {
                            name
                          }
                          models {
                            ... on SanityVehicleModel {
                              _key
                              _type
                              model {
                                ... on SanityModel {
                                  _id
                                  id
                                  name
                                  grade
                                  year
                                  series {
                                    name
                                    currentYear
                                  }
                                  code
                                }
                                ... on SanityCustomModel {
                                  _id
                                  id
                                  name
                                  grade
                                  year
                                  series {
                                    name
                                    currentYear
                                  }
                                }
                              }
                            }
                            ... on SanityVehicleModelGroup {
                              _key
                              _type
                              title
                              models {
                                model {
                                  ... on SanityModel {
                                    _id
                                    id
                                    name
                                    code
                                    grade
                                    series {
                                      currentYear
                                      name
                                    }
                                    year
                                  }
                                  ... on SanityCustomModel {
                                    _id
                                    id
                                    name
                                    grade
                                    year
                                    series {
                                      name
                                      currentYear
                                    }
                                  }
                                }
                              }
                            }
                          }
                          year
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const extractedModelGroups = data2?.allSanityFamily?.nodes
    ?.flatMap((node: Family) => node.routes)
    .flatMap((route: Route) => route.route.page)
    .flatMap(
      (page: {
        vehicle: {
          models: ModelGroup[]
          year: string
          series: { name: string }
        }
        relatedSeriesPage: {
          page: { vehicle: { models: ModelGroup[]; year: string } }
        }
      }) => {
        const vehicleModelGroups =
          page.vehicle?.models?.map((modelGroup: ModelGroup) => {
            const modelsData =
              modelGroup?._type === "vehicleModelGroup"
                ? {
                    modelGroup: {
                      name: `${page?.vehicle?.year} ${modelGroup?.title}`,
                    },
                    year: page?.vehicle?.year,
                    models: modelGroup.models?.flatMap(mo => mo.model) || [],
                  }
                : modelGroup?._type === "vehicleModel"
                  ? {
                      modelGroup: {
                        name: `${page?.vehicle?.year} ${modelGroup?.model?.name}`,
                      },
                      year: page?.vehicle?.year,
                      models: [modelGroup.model],
                    }
                  : null
            return modelsData
          }) || []

        const relatedModelGroups =
          page.relatedSeriesPage?.page?.vehicle?.models?.flatMap(modelGroup => {
            const modelsData =
              modelGroup?._type === "vehicleModelGroup"
                ? {
                    modelGroup: {
                      name: `${page?.relatedSeriesPage?.page?.vehicle?.year} ${modelGroup?.title}`,
                    },
                    year: page?.relatedSeriesPage?.page?.vehicle?.year,
                    models: modelGroup.models?.flatMap(mo => mo.model) || [],
                  }
                : modelGroup?._type === "vehicleModel"
                  ? {
                      modelGroup: {
                        name: `${page?.relatedSeriesPage?.page?.vehicle?.year} ${modelGroup?.model?.name}`,
                      },
                      year: page?.relatedSeriesPage?.page?.vehicle?.year,
                      models: [modelGroup.model],
                    }
                  : null
            return modelsData
          }) || []

        return {
          series: page?.vehicle?.series?.name,
          modelGroups: [...vehicleModelGroups, ...relatedModelGroups],
        }
      },
    )
    .filter((model: { series: any }) => model.series)
    .reduce((acc: any[], current: { series: any }) => {
      const x = acc.find(item => item.series === current.series)
      if (!x) {
        return acc.concat([current])
      } else {
        return acc
      }
    }, [])

  const modelGroupstoSeries = extractedModelGroups.reduce(
    (
      acc: { [x: string]: any[] },
      model: { series: string; modelGroups: any },
    ) => {
      const seriesName =
        model.series?.toLowerCase().replace(/[\s-]+/g, "") || "Unknown Series"
      if (!acc[seriesName]) {
        acc[seriesName] = []
      }
      acc[seriesName].push(...model.modelGroups)
      return acc
    },
    {},
  )

  const modelsData = {
    models: modelGroupstoSeries,
    series: Object.keys(modelGroupstoSeries).map(seriesName => {
      const firstModel = modelGroupstoSeries[seriesName][0].models[0]
      return { name: firstModel?.series.name }
    }),
  }

  return { modelsData }
}
export default useModelData
